import api from '../../api'

const getDefaultState = () => {
  return {
    all: []
  }
}

const state = getDefaultState()

const getters = {
  getAll: (state) => state.all,
  getTranslation: (state) => () => {
    return state.all
  }
}

const actions = {
  fetchAll ({ commit }) {
    return new Promise((resolve) => {
      api.getTranslation()
        .then(data => {
          commit('setTranslation', data)
          resolve()
        })
    })
  },
  reset ({ commit }) {
    commit('resetState')
  }
}

const mutations = {
  setTranslation(state, data) {
    Object.assign(state.all, data)
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
